<ul class="nav justify-content-center">
  <li class="nav-item" *ngFor="let link of links" >
    <a class="nav-link small" href="{{link.path}}">{{link.name}}</a>
  </li>
</ul>

